import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  FormControl,
  Select,
  Typography,
  useTheme,
} from "@material-ui/core";
import ArrowBackIosOutlinedIcon from "@material-ui/icons/ArrowBackIosOutlined";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import managerLessonApi from "api/managerLesson";
import LOGO from "assets/img/logo.png";
import BACKGROUND_1234 from "assets/img/slide_month_1234.png";
import BACKGROUND_5678 from "assets/img/slide_month_5678.png";
import BACKGROUND_9101112 from "assets/img/slide_month_9101112.png";
import {ListSlideMonth, SlideMonth} from "models/managerLesson";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Slider from "react-slick";
import useStyles from "../style";

export default function CarouselMonthMobile() {
  const classes = useStyles();
  function SampleNextArrow(props: any) {
    const {className, style, onClick} = props;
    return (
      <ArrowForwardIosIcon
        className={className}
        style={{...style, color: "#E95869", display: "block", fontSize: 30}}
        onClick={onClick}
      />
    );
  }
  function SamplePrevArrow(props: any) {
    const {className, style, onClick} = props;
    return (
      <ArrowBackIosOutlinedIcon
        className={className}
        style={{...style, color: "#E95869", display: "block", fontSize: 30}}
        onClick={onClick}
      />
    );
  }

  const settings = {
    infinite: true,
    slidesToShow: 3,
    dots: false,
    slidesToScroll: 3,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const currentMonth = new Date().getMonth() + 1;
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [listSlideMonth, setListSlideMonth] = useState<SlideMonth[]>([]);
  const navigate = useNavigate();
  const sliderRef = useRef<any>();
  const handleChangeYear = (event: React.ChangeEvent<{value: unknown}>) => {
    setYear(Number(event.target.value));
  };

  useEffect(() => {
    (async () => {
      try {
        const res: ListSlideMonth<SlideMonth> = await managerLessonApi.getSlideMonth(year);
        setListSlideMonth(res.lessionOverview);
      } catch (error) {}
    })();
  }, [year]);

  useEffect(() => {
    sliderRef?.current?.slickGoTo(currentMonth < 5 ? 0 : currentMonth < 9 ? 4 : 8);
  }, []);
  return (
    <Box className={classes.container}>
      <Box mb={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            native
            value={year}
            onChange={handleChangeYear}
            defaultValue={new Date().getFullYear()}
          >
            {Array.from(new Array(10)).map((id, index) => (
              <option value={index + 2020} key={index + 1}>
                {index + 2020}
              </option>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Slider {...settings} ref={sliderRef}>
        {listSlideMonth?.map((item, index) => (
          <Box key={index} style={{height: "100vh"}}>
            <Card
              className={classes.card}
              style={{
                borderBottom:
                  item.month < 4
                    ? "7px solid #E95869"
                    : item.month < 7
                    ? "7px solid #FCAB51"
                    : item.month < 10
                    ? "7px solid #2495DC"
                    : "7px solid #FCAB51",
              }}
            >
              <CardMedia
                className={classes.contentMedia}
                image={
                  item.month < 4
                    ? BACKGROUND_1234
                    : item.month < 7
                    ? BACKGROUND_5678
                    : item.month < 10
                    ? BACKGROUND_9101112
                    : BACKGROUND_5678
                }
              >
                <Box className={classes.currentMonth}>
                  {item.month === currentMonth && <img src={LOGO} alt="LOGO" />}
                </Box>
                <Box className={classes.month}>
                  <Typography variant="subtitle2">
                    {item.month < 10 ? `0${item.month}` : item.month}
                  </Typography>
                </Box>
              </CardMedia>

              <CardContent>
                <Box className={classes.card__content}>
                  <Typography variant="subtitle2">SỐ BÀI HỌC HOÀN THÀNH</Typography>
                  <Box className={classes.totalWatched}>
                    <Typography variant="subtitle2" component="span">
                      {" "}
                      {item.noWatchedLession}
                    </Typography>
                    <Typography variant="subtitle2" component="i">
                      / {item.noTotalLession}
                    </Typography>
                  </Box>
                </Box>

                <Box textAlign="center">
                  <Button
                    className={classes.btn_detail}
                    style={{
                      backgroundColor:
                        item.month < 4
                          ? " #E95869"
                          : item.month < 7
                          ? " #FCAB51"
                          : item.month < 10
                          ? " #2495DC"
                          : "#FCAB51",
                    }}
                    onClick={() =>
                      navigate({
                        pathname: "/list-lesson",
                        search: `year=${year}&month=${
                          item.month < 10 ? `0${item.month}` : item.month
                        }`,
                      })
                    }
                  >
                    Xem thêm
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
